'use client';

import {useContext} from 'react';
import {ThemeContext} from '../../utils/ThemeContext';

const Double = ({data}) => {
  const {theme} = useContext(ThemeContext);
  const {id, subtitle, title, list, image, imageLight, color, bg, bgLight, reverseClass, honeycombClass} = data;
  const imgSrc = theme === 'dark' ? image : imageLight;
  const imgStyle = {backgroundImage: `url(${imgSrc})`};
  const bgSrc = theme === 'dark' ? bg : bgLight;
  const bgStyle = {background: `${bgSrc}`};

  const listItems = list.map((item, index) => {
    const {listText} = item;
    return (
      <li className='list-item' key={index}>
        {listText}
      </li>
    );
  });

  return (
    <section className={`double ${honeycombClass} ${id}`} id={id}>
      <div className={`container ${reverseClass}`}>
        <div className={`image-container`} style={bgStyle}>
          <div className='img' style={imgStyle} />
        </div>
        <div className='content-container'>
          <div className='content'>
            <h3 className={`subtitle ${color}`}>{subtitle}</h3>
            <h2 className='title'>{title}</h2>
            <ul className='list'>{listItems}</ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Double;

